import React from 'react';
import PropTypes from 'prop-types';
import AccessTimeIcon from '@mui/icons-material/AccessTime';
import CancelOutlinedIcon from '@mui/icons-material/CancelOutlined';
import CheckIcon from '@mui/icons-material/Check';
import ReportProblemOutlinedIcon from '@mui/icons-material/ReportProblemOutlined';

import { Text, Tooltip } from 'components/DataDisplay';
import { Item } from 'components/Layout';

import { isUpsertLastAction, SETUP_IN_PROGRESS_STATUSES } from '../../../utils';

export const getMediaStatus = (
  designSystem,
  activableMedia,
  setupTask,
  mediaOrderId,
  isUpsertPending = false,
  lastUpsertTask = null
) => {
  if (!activableMedia || activableMedia.canSetUp !== true) {
    return {
      label: 'Setup manuel',
      bg: designSystem.amberBg,
      color: designSystem.amber,
      icon: 'warning'
    };
  }
  const taskRef = setupTask?.mediaOrderStatus?.[mediaOrderId] || setupTask;
  if (
    isUpsertPending &&
    isUpsertLastAction(lastUpsertTask, setupTask, taskRef?.status)
  ) {
    return {
      label: 'Upsert en attente de setup',
      bg: designSystem.orangeBg,
      color: designSystem.orange,
      icon: 'clock'
    };
  }
  if (!setupTask) {
    return {
      label: 'Synchronisable',
      bg: designSystem.blueBg,
      color: designSystem.blue,
      icon: null
    };
  }
  switch (taskRef.status) {
    case 'done':
      return {
        label: 'Synchronisé',
        bg: designSystem.greenBg,
        color: designSystem.greenDark,
        icon: 'check'
      };
    case 'error':
      return {
        label: 'Erreur',
        bg: designSystem.redBg,
        color: designSystem.red,
        icon: 'cancel',
        tooltip: taskRef.errorMsg
      };
    case 'aborted':
      return {
        label: 'Annulé',
        bg: designSystem.redBg,
        color: designSystem.red,
        icon: 'cancel',
        tooltip: taskRef.errorMsg
      };
    case 'queued':
      return {
        label: 'En attente',
        bg: designSystem.bgSoft,
        color: designSystem.muted,
        icon: 'clock',
        tooltip: taskRef.errorMsg || "En file d'attente du compte publicitaire"
      };
    case 'partial':
      return {
        label: 'Setup manuel',
        bg: designSystem.greenBg,
        color: designSystem.greenDark,
        icon: 'check'
      };
    default:
      if (SETUP_IN_PROGRESS_STATUSES.includes(taskRef.status)) {
        return {
          label: 'En cours',
          bg: designSystem.bgSoft,
          color: designSystem.muted,
          icon: null
        };
      }
      return {
        label: 'Synchronisable',
        bg: designSystem.blueBg,
        color: designSystem.blue,
        icon: null
      };
  }
};

export const StatusPill = ({ status }) => {
  const pillIcon = key => {
    if (key === 'warning') {
      return (
        <ReportProblemOutlinedIcon
          style={{ fontSize: '13px', color: status.color }}
        />
      );
    }
    if (key === 'check') {
      return <CheckIcon style={{ fontSize: '13px', color: status.color }} />;
    }
    if (key === 'cancel') {
      return (
        <CancelOutlinedIcon style={{ fontSize: '13px', color: status.color }} />
      );
    }
    if (key === 'clock') {
      return (
        <AccessTimeIcon style={{ fontSize: '13px', color: status.color }} />
      );
    }
    return null;
  };

  const pill = (
    <Item
      flex
      style={{
        alignItems: 'center',
        gap: '4px',
        borderRadius: '20px',
        padding: '3px 9px',
        backgroundColor: status.bg,
        whiteSpace: 'nowrap'
      }}
    >
      {pillIcon(status.icon)}
      <Text
        component="span"
        fontSize="11px"
        fontWeight={600}
        style={{ color: status.color, lineHeight: 1.3 }}
      >
        {status.label}
      </Text>
    </Item>
  );

  return status.tooltip ? (
    <Tooltip title={status.tooltip}>{pill}</Tooltip>
  ) : (
    pill
  );
};

StatusPill.propTypes = {
  status: PropTypes.shape().isRequired
};

export default StatusPill;
